module.exports = __webpack_public_path__ + "static/media/event.ec461152.png";